import {useSiteImages} from '../hooks/useSiteImages';

function BrandMark({light = false}) {
  const {url} = useSiteImages();
  const logoUrl = url('logo');

  return (
    <a className={`brand ${light ? 'brand--light' : ''}`} href="/#home" aria-label="Leopard Bliss Yala home">
      {logoUrl && <img className="brand__logo" src={logoUrl} alt="Leopard Bliss Yala logo" />}
      <span className="brand__words">
        <strong>LEOPARD BLISS</strong>
        <small>YALA · SRI LANKA</small>
      </span>
    </a>
  );
}

export default BrandMark;